module.exports = __webpack_public_path__ + "img/ic_telegram.ea0840bb.svg";